import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "cpfCnpj",
})
export class CpfCnpjPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return;

        const cleanValue = value.replace(/[^\d]/g, "");
        const isCnpj = cleanValue.length === 14;

        if (isCnpj) {
            return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        } else {
            return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
    }
}
